import React from 'react'
import PropTypes from 'prop-types'
import Resource from 'common/components/Resource'
import Form from '../form'
import actions from '../actions'

const handleSubmit = id => async (values, form) => {
  const {
    country,
    name,
    region,
    timezoneName
  } = values

  const {
    setSubmitting,
    setErrors,
    setStatus
  } = form

  try {
    await actions.update(id, {
      name,
      country,
      region,
      timezone_name: timezoneName
    })

    setStatus({ success: true })
  } catch (e) {
    setErrors({ http: e.message })
  }
  setSubmitting(false)
}

const Edit = ({ match }) => (
  <Resource
    name='cities'
    resourceId={match.params.id}
    render={city => (
      <Form
        isEdit
        handleSubmit={handleSubmit(match.params.id)}
        initialValues={
          {
            name: city.name || '',
            region: city.region || '',
            country: city.country || '',
            timezoneName: city.timezone_name || ''
          }
        }
      />
    )} />)

Edit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
}

export default Edit
